import NewsTipAdvancedForm from './NewsTipAdvancedForm'

export default NewsTipAdvancedForm
